import React from "react";
import moment from "moment-timezone";
import PageLoader from "../ui/PageLoader";

const ContactAlertDetails = ({ alertData, isLoading, isError, error }) => {
  if (isLoading) {
    return <PageLoader />;
  }

  if (isError) {
    return (
      <div className="text-center text-red-500">
        <p>Error loading alert details</p>
        <p className="text-sm">{error?.message}</p>
      </div>
    );
  }

  if (!alertData) {
    return (
      <div className="text-center text-mediumgray">
        <p>No alert data found</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="border-b pb-4">
        <h5 className="font-medium text-lg">{alertData.alertName}</h5>
        <p className="text--darkgray mt-1">{alertData.message}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <h6 className="font-medium text-sm">Trigger Date</h6>
          <p className="text--darkgray">
            {moment(alertData.triggerDate)
              .tz("Australia/Sydney")
              .format("D MMM YYYY")}
          </p>
        </div>

        {alertData.expiryDate && (
          <div>
            <h6 className="font-medium text-sm">Expiry Date</h6>
            <p className="text--darkgray">
              {moment(alertData.expiryDate)
                .tz("Australia/Sydney")
                .format("D MMM YYYY")}
            </p>
          </div>
        )}

        <div>
          <h6 className="font-medium text-sm">Recurring</h6>
          <p className="text--darkgray capitalize">{alertData.recurring}</p>
        </div>

        <div>
          <h6 className="font-medium text-sm">Created By</h6>
          <p className="text--darkgray">{alertData.createdBy || "Admin"}</p>
        </div>
      </div>

      <div className="border-t pt-4">
        <h6 className="font-medium mb-3">
          Target Contacts ({alertData.contacts?.length || 0})
        </h6>

        {alertData.contacts && alertData.contacts.length > 0 ? (
          <div className="max-h-60 overflow-y-auto">
            <div className="space-y-2">
              {alertData.contacts.map((contact, index) => (
                <div
                  key={contact.contactId || index}
                  className="flex flex-col sm:flex-row sm:items-center justify-between p-3 bg-lightergray rounded"
                >
                  <div className="flex-1">
                    <h6 className="font-medium text-sm">{contact.name}</h6>
                    <div className="flex flex-wrap gap-4 text-xs text--darkgray mt-1">
                      {contact.email && <span>📧 {contact.email}</span>}
                      {contact.phone && <span>📱 {contact.phone}</span>}
                      {contact.suburb && <span>📍 {contact.suburb}</span>}
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mt-2 sm:mt-0">
                    {contact.group && (
                      <span className="px-2 py-1 text-xs bg-blue-100 text-blue-800 rounded">
                        {contact.group}
                      </span>
                    )}
                    {contact.cookies && (
                      <span className="px-2 py-1 text-xs bg-purple-100 text-purple-800 rounded">
                        {contact.cookies}
                      </span>
                    )}

                    {/* Boolean filter badges */}
                    <div className="flex flex-wrap gap-1">
                      {contact.isDeveloper && (
                        <span className="px-1 py-0.5 text-xs bg-black text-white rounded">
                          Dev
                        </span>
                      )}
                      {contact.smsSales && (
                        <span className="px-1 py-0.5 text-xs bg-black text-white rounded">
                          SMS
                        </span>
                      )}
                      {contact.isCleaned && (
                        <span className="px-1 py-0.5 text-xs bg-black text-white rounded">
                          Clean
                        </span>
                      )}
                      {contact.pastPurchaser && (
                        <span className="px-1 py-0.5 text-xs bg-black text-white rounded">
                          P.Buyer
                        </span>
                      )}
                      {contact.pastVendor && (
                        <span className="px-1 py-0.5 text-xs bg-black text-white rounded">
                          P.Vendor
                        </span>
                      )}
                      {contact.hasWhatsapp && (
                        <span className="px-1 py-0.5 text-xs bg-green-600 text-white rounded">
                          WA
                        </span>
                      )}
                      {contact.cookieActive && (
                        <span className="px-1 py-0.5 text-xs bg-orange-600 text-white rounded">
                          Cookie
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p className="text-mediumgray text-center py-4">
            No contacts found for this alert
          </p>
        )}
      </div>
    </div>
  );
};

export default ContactAlertDetails;
